<template>
  <md-toolbar
    style="md-dense; z-index: 4"
    md-elevation="0"
    class="md-transparent noprint"
    :class="{
      'md-toolbar-absolute md-white md-fixed-top': $route.meta.navbarAbsolute,
    }"
  >
    <div class="md-toolbar-row noprint">
      <div class="md-toolbar-section-start">
        <h3 style="font-weight:bold;" class="md-title">{{ $route.name }}</h3>
      </div>
      <div class="md-toolbar-section-end">
        <md-button
          class="md-just-icon md-round md-simple md-toolbar-toggle"
          :class="{ toggled: $sidebar.showSidebar }"
          @click="toggleSidebar"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </md-button>
        
        

        <!-- <li class="button-container" style="margin-right: 10px">
          <div class="">
            <md-button
              class="md-default md-block"
              :href="documentationLink"
              target="_blank"
              >Documentation
            </md-button>
          </div>
        </li>

        <li class="button-container">
          <div class="">
            <md-button
              class="md-success md-block"
              :href="downloadUrl"
              target="_blank"
              >Download Now
            </md-button>
          </div>
        </li> -->

        <div class="md-collapse">
          <!-- <div class="md-autocomplete">
            <md-autocomplete
              class="search"
              v-model="selectedEmployee"
              :md-options="employees"
              :md-open-on-focus="false"
            >
              <label v-if="$route.meta.rtlActive">بحث...</label>
              <label v-else>Search...</label>
            </md-autocomplete>
          </div> -->
          <md-list>
            <!-- <md-list-item href="#/">
              <i class="material-icons">dashboard</i>
              <p class="hidden-lg hidden-md">Dashboard</p>
            </md-list-item> -->

            <li class="md-list-item">
              <a
                @click="goToNotifications"
                class="md-list-item-router md-list-item-container md-button-clean dropdown"
              >
                <div class="md-list-item-content">
                  <drop-down direction="down">
                    <md-button
                      slot="title"
                      class="md-button md-just-icon md-simple"
                      data-toggle="dropdown"
                    >
                      <md-icon>notifications</md-icon>
                      <span v-if="jumlah_notifikasi!=0 || jumlah_notifikasi!=''" class="notification">{{jumlah_notifikasi}}</span>
                      <p class="hidden-lg hidden-md">Notifications</p>
                    </md-button>
                    <ul style="z-index: 9999;" class="dropdown-menu dropdown-menu-right notifications-ul"  >
                      <!-- <li><a href="#">Mike John responded to your email</a></li>
                      <li><a href="#">You have 5 new tasks</a></li>
                      <li><a href="#">You're now friend with Andrew</a></li>
                      <li><a href="#">Another Notification</a></li>
                      <li><a href="#">Another One</a></li> -->
                      <li class="notifications-li" v-for="item in list_notifikasi" :key="item.id" @click="selectNotif(item.id,item.data.url,item.data.no,item.data.id,item.data)">
                        
                        <!-- <a><p>{{item.data.header}}</p><br><br>{{item.data.message}}</a> -->
                        <!-- <a class="notifications-a" :href=item.data.url> -->
                        <!-- <div v-bind:class="{'text-danger': hasError }" class="md-layout-item md-medium-size-5 md-xsmall-size-50 md-size-5">
                            <stats-card header-color="blue">
                              <template slot="header">
                                <div class="card-icon">
                                   <md-icon>announcement</md-icon>
                                </div>
                                <p class="category">{{item.data.header}}</p>
                                <h5 class="title">
                                  {{item.data.no}}
                                </h5>
                              </template>
                              

                              <template slot="footer">
                                <div class="stats">
                                  {{item.data.message}}
                                </div>
                              </template>
                            </stats-card>
                          </div> -->
                          <div class="notifications-item"> 
                                <div class="text">
                                    <h4>{{item.data.header}}</h4>
                                    <p>{{item.data.message}}</p>
                                    <p>{{item.data.date_time}}</p>
                                </div>
                            </div>
                          <!-- </a> -->
                      </li>
                    </ul>
                  </drop-down>
                </div>
              </a>
            </li>

            <md-list-item @click="goToUsers"> 
              <i class="material-icons">person</i>
              <p class="hidden-lg hidden-md">Profile</p>
            </md-list-item>
          </md-list>
        </div>
      </div>
    </div>
  </md-toolbar>
</template>
<script>
import Echo from 'laravel-echo';
import Pusher from "pusher-js"

//instantiate Pusher untuk medapatkan notification dari api menggunakan broadcaster pusher server
//menggunakan token user untuk dapat mengakses API
console.log(process.env.VUE_APP_API_AUTH_URL)
 window.Echo = new Echo({
    broadcaster: 'pusher',
    key: process.env.VUE_APP_PUSHER_APP_KEY,
    cluster: process.env.VUE_APP_PUSHER_APP_CLUSTER,
  forceTLS: true, 
    authEndpoint : process.env.VUE_APP_API_AUTH_URL,
    auth: {
        headers: {
            'Authorization': 'Bearer '+ localStorage.getItem('vue-authenticate.vueauth_access_token'),
            'Accept': 'application/vnd.api+json'
        }
    }
});
import {
  StatsCard,
} from "@/components";
export default {
  props: ['notification','user'],
  watch: { 
        //pantau perubahan data notifikasi 
      	notification: function(newVal, oldVal) { 
          // watch it
          //jika ada set var notif dengan data notification yang baru
          this.notif = newVal
        }
      },
  data() {
    return {
      notif: this.notification,
      jumlah_notifikasi:"",
      list_notifikasi:"",
      selectedEmployee: "",
      employees: [
        "Jim Halpert",
        "Dwight Schrute",
        "Michael Scott",
        "Pam Beesly",
        "Angela Martin",
        "Kelly Kapoor",
        "Ryan Howard",
        "Kevin Malone",
      ],
      documentationLink:
        "https://vue-material-dashboard-laravel.creative-tim.com/documentation/",
      downloadUrl:
        "https://www.creative-tim.com/product/vue-material-dashboard-laravel",
    };
  },
 created() {
      this.listenForChanges();
    },
  methods: {
    listenForChanges() {
      //console.log(this.notif)
      this.updateNotification()

    
       //hubungkan echo dengan private chanel sesaui dengan user yang login, untuk mendapatkan notifikasi per user
        window.Echo.private('App.Models.User.'+this.user.id)
          .listen(".Illuminate\\Notifications\\Events\\BroadcastNotificationCreated", data => {
            if (! ('Notification' in window)) {
              alert('Web Notification is not supported');
              return;
            }
            console.log(data)
             this.notif.push({id: data.id, type: data.type  , data: {header: data.header, id: data.id_item, message: data.message, no: data.no, remark:  data.remark, url:  data.url} });
             this.updateNotification()
            Notification.requestPermission( permission => {
              let notification = new Notification(data.message, {
                body: data.header, // content for the alert
                icon: "https://pusher.com/static_logos/320x320.png" // optional image url
              });

              // link to page on clicking the notification
              notification.onclick = () => {
                window.open(window.location.href);
              };
            });
          })
      },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    },
    goToNotifications() {
      // this.$router.push({ name: "Notifications" });
    },
    goToUsers() {
      this.$router.push({ name: "User Profile" });
    },
    //fungsi untuk mengupdate data list_notifikasi dan jumlah notifikasi
    updateNotification(){
      this.jumlah_notifikasi = this.notif.length
      this.list_notifikasi  = this.notif
    },
    //fungsi untuk menuju page yg di informasikan ketika mengclick notif
    async selectNotif(id_notif,url,no,id,data_param){
      const data = {
          type: "notification",
          id: id_notif,
          
        }
      try {
        //await this.$store.dispatch("notification/markNotification", data)
        // if(url == "Spare Part Master"){
        //   await this.$router.push({name: 'List '+url, query: { search: no }}).catch(error => {
        //     if (error.name != "NavigationDuplicated") {
        //       throw error;
        //     }
        //   });
        // }
         
        // else{
        //   await this.$router.push({name: 'Detail '+url, params: { id }}).catch(error => {
        //     if (error.name != "NavigationDuplicated") {
        //       throw error;
        //     }
        //   });
        // }

        if(url == "Driver Taxi"){
          //check apakah refs ada di root,
          if(this.$route.name == "List Driver Taxi" && this.$root.$refs.ListDriverPage){
            //jika ada panggil function
             this.$root.$refs.ListDriverPage.detailDriver(id);
          }else{
            await this.$router.push({name:  'List Driver Taxi',  params: { id }}).catch(error => {
              if (error.name != "NavigationDuplicated") {
                throw error;
              }
            });
          }

        
        }
        else if(url == "Driver Blackplate"){
          //check apakah refs ada di root,
          if(this.$route.name == "List Driver Black Plate" && this.$root.$refs.ListDriverBlackPlatePage.detailDriver){
            //jika ada panggil function
             this.$root.$refs.ListDriverBlackPlatePage.detailDriver(id);
          }else{
            await this.$router.push({name:  'List Driver Black Plate',  params: { id }}).catch(error => {
              if (error.name != "NavigationDuplicated") {
                throw error;
              }
            });
          }

        
        }
        else if(url == "Vehicle"){
          //check apakah refs ada di root,
          if(this.$route.name == "List Vehicle" && this.$root.$refs.ListVehiclePage.detailVehicle){
            //jika ada panggil function
             this.$root.$refs.ListVehiclePage.detailVehicle(id);
          }else{
            await this.$router.push({name:  'List Vehicle',  params: { id }}).catch(error => {
              if (error.name != "NavigationDuplicated") {
                throw error;
              }
            });
          }

        
        }

        else if(url == "PKO Taxi"){
          //check apakah refs ada di root,
          if(this.$route.name == "List PKO Taxi" && this.$root.$refs.ListPkoTaxiPage.detailPko){
            //jika ada panggil function 
             this.$root.$refs.ListPkoTaxiPage.detailPko(id);
          }else{
            await this.$router.push({name:  'List PKO Taxi',  params: { id }}).catch(error => {
              if (error.name != "NavigationDuplicated") {
                throw error;
              }
            });
          }

        
        }
        else if(url == "PKO"){
          //check apakah refs ada di root,
          if(this.$route.name == "List PKO" && this.$root.$refs.ListPkoPage.detailPko){
            //jika ada panggil function
             this.$root.$refs.ListPkoPage.detailPko(id);
          }else{
            await this.$router.push({name:  'List PKO',  params: { id }}).catch(error => {
              if (error.name != "NavigationDuplicated") {
                throw error;
              }
            });
          }

        
        }
        else if(url == "PKO Ownership"){
          //check apakah refs ada di root,
          if(this.$route.name == "List PKO Ownership" && this.$root.$refs.ListPkoBlackPlateOwnershipPage.detailPkoOwnership){
            //jika ada panggil function
             this.$root.$refs.ListPkoBlackPlateOwnershipPage.detailPOwnership(id);
          }else{
            await this.$router.push({name:  'List PKO Ownership',  params: { id }}).catch(error => {
              if (error.name != "NavigationDuplicated") {
                throw error;
              }
            });
          }

        
        }
        else if(url == "Bizdev Vehicle"){
          //check apakah refs ada di root,
          if(this.$route.name == "List Logi Vehicle" && this.$root.$refs.ListBizdevVehicletPage.detailLV){
            //jika ada panggil function
             this.$root.$refs.ListBizdevVehicletPage.detailLV(id);
          }else{
            await this.$router.push({name:  'List Logi Vehicle',  params: { id }}).catch(error => {
              if (error.name != "NavigationDuplicated") {
                throw error;
              }
            });
          }

        
        }
        else if(url == "Bizdev Contract"){
          //check apakah refs ada di root,
          if(this.$route.name == "List Logi Contract" && this.$root.$refs.ListBizdevContractPage.detailRVE){
            //jika ada panggil function
             this.$root.$refs.ListBizdevContractPage.detailRVE(id);
          }else{
            await this.$router.push({name:  'List Logi Contract',  params: { id }}).catch(error => {
              if (error.name != "NavigationDuplicated") {
                throw error;
              }
            });
          }

        
        }
        else if(url == "Rental Vehicle Employee Admin"){
          //check apakah refs ada di root,
          if(this.$route.name == "List Rental Vehicle Employee Admin" && this.$root.$refs.ListHRRentalEmployeePage.detailRVE){
            //jika ada panggil function
             this.$root.$refs.ListHRRentalEmployeePage.detailRVE(id);
          }else{
            await this.$router.push({name:  'List Rental Vehicle Employee Admin',  params: { id }}).catch(error => {
              if (error.name != "NavigationDuplicated") {
                throw error;
              }
            });
          }

        
        }
        else if(url == "Rental Vehicle Employee"){
          //check apakah refs ada di root,
          if(this.$route.name == "List Rental Vehicle Employee" && this.$root.$refs.ListHRRentalEmployeePage.detailRVE){
            //jika ada panggil function
             this.$root.$refs.ListHRRentalEmployeePage.detailRVE(id);
          }else{
            await this.$router.push({name:  'List Rental Vehicle Employee',  params: { id }}).catch(error => {
              if (error.name != "NavigationDuplicated") {
                throw error;
              }
            });
          }

        
        }

        else if(url == "Vehicle Service Reminder"){
          //check apakah refs ada di root,
            await this.$router.push({name:  'List Vehicle Service Reminder',  query: { search: data_param.plate_no }}).catch(error => {
              if (error.name != "NavigationDuplicated") {
                throw error;
              }
            });
          

        
        }
        
        await this.$store.dispatch("notification/markNotification", data)
        console.log();

        var indexOptionNotif = this.notif.findIndex(p => p.id ==  id_notif)
           this.notif.splice(indexOptionNotif, 1)

        //var userData = await this.$store.getters["profile/me"]
        //console.log(userData)
        // if(userData.notification.length != 0){
          //this.notif = userData.notification
        // }
        // else{
        //   this.notification = []
        // }
        
          this.updateNotification()

            //remove notif from list by index
          //this.notif.splice(index, 1)

      } catch (e) {
        await this.$store.dispatch(
          "alerts/error",
          "Oops, something went wrong"
        );
        console.log(e)
    }
    }
  },
 mounted() {
        console.log('Component mounted.')
         //this.listenForChanges();
        
        
    }
};
</script>
<style>

.notifications-ul {
    max-height: 400px;
    overflow-y: auto;
    overflow-x: hidden;
}
.notifications-li {
  display: flex;  
  flex-wrap: wrap;
}

.notifications-a {
   margin: 0.5px !important;
  padding: 0.5px !important;
}
.notifications-item {
    display: inline-block;
    border-bottom: 1px solid #eee;
    padding: 6px 9px;
    margin-bottom: 0px;
    cursor: pointer
}
.notifications-item:hover {
    background-color: #eee
}



.notifications-item .text h4 {
    color: #777;
    font-size: 16px;
    /* margin-top: 3px */
     margin: 0.5px !important;
}

.notifications-item .text p {
    color: #aaa;
    font-size: 10px;
    max-width: 150px;
    text-overflow: ellipsis;
    white-space: initial;
    display: inline-block;
    overflow:hidden;
     margin: 0.5px !important;
}

@media print {
  .print {
    visibility: visible;
  }
  .noprint {
    display: none;
  }
}

</style>